import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { SelectOption, SelectProps } from '@ui';

// constants
import { SourceOfWealthCategories } from 'enums/onboarding/crm';

// components
import { FormSelect } from '@ui';

export type IProps = SelectProps;

const SourceOfWealthSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(SourceOfWealthCategories).map((key) => ({
        id: key,
        label: t(`source_of_wealth.source_of_wealth_categories.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default SourceOfWealthSelect;
